<template>
  <section id="checkout-form">
    <PaypalComponent
      :heading="fields?.tr_paypal_upsell_title"
      :text="fields?.tr_paypal_upsell_text"
      :upsellYes="fields?.tr_paypal_upsell_yes_text"
      :upsellNo="fields?.tr_paypal_upsell_no_text"
      :price="cart?.paypalUpsellPrice"
      :image="fields?.paypal_upsell_image"
      :konnektiveCampaignId="fields?.konnektive_campaign_id"
      @loading="(status) => (loading = status)"
      v-if="paypalFunnel"
    />

    <div v-if="cart.paypalEnabled" class="w_paypal" v-on:click="startPaypalFunnel">
      <div class="w_radio">
        <label for="paypal_method">
          <svg class="b-loaded" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 170 48">
            <g clip-path="url(#a)">
              <path
                fill="#003087"
                d="M62.56 28.672a10.111 10.111 0 0 0 9.983-8.56c.78-4.967-3.101-9.303-8.6-9.303H55.08a.689.689 0 0 0-.69.585l-3.95 25.072a.643.643 0 0 0 .634.742h4.69a.689.689 0 0 0 .688-.585l1.162-7.365a.689.689 0 0 1 .689-.586h4.257Zm3.925-8.786c-.29 1.836-1.709 3.189-4.425 3.189h-3.474l1.053-6.68h3.411c2.81.006 3.723 1.663 3.435 3.496v-.005Zm26.378-1.18H88.41a.69.69 0 0 0-.69.585l-.144.924s-3.457-3.775-9.575-1.225c-3.51 1.461-5.194 4.48-5.91 6.69 0 0-2.277 6.718 2.87 10.417 0 0 4.771 3.556 10.145-.22l-.093.589a.642.642 0 0 0 .634.742h4.451a.689.689 0 0 0 .69-.585l2.708-17.175a.643.643 0 0 0-.634-.742Zm-6.547 9.492a4.996 4.996 0 0 1-4.996 4.276 4.513 4.513 0 0 1-1.397-.205c-1.92-.616-3.015-2.462-2.7-4.462a4.996 4.996 0 0 1 5.014-4.277c.474-.005.946.065 1.398.206 1.913.614 3.001 2.46 2.686 4.462h-.005Z"
              />
              <path
                fill="#0070E0"
                d="M126.672 28.672a10.115 10.115 0 0 0 9.992-8.56c.779-4.967-3.101-9.303-8.602-9.303h-8.86a.69.69 0 0 0-.689.585l-3.962 25.079a.637.637 0 0 0 .365.683.64.64 0 0 0 .269.06h4.691a.69.69 0 0 0 .689-.586l1.163-7.365a.688.688 0 0 1 .689-.586l4.255-.007Zm3.925-8.786c-.29 1.836-1.709 3.189-4.426 3.189h-3.473l1.054-6.68h3.411c2.808.006 3.723 1.663 3.434 3.496v-.005Zm26.377-1.18h-4.448a.69.69 0 0 0-.689.585l-.146.924s-3.456-3.775-9.574-1.225c-3.509 1.461-5.194 4.48-5.911 6.69 0 0-2.276 6.718 2.87 10.417 0 0 4.772 3.556 10.146-.22l-.093.589a.637.637 0 0 0 .365.683c.084.04.176.06.269.06h4.451a.686.686 0 0 0 .689-.586l2.709-17.175a.657.657 0 0 0-.148-.518.632.632 0 0 0-.49-.224Zm-6.546 9.492a4.986 4.986 0 0 1-4.996 4.276 4.513 4.513 0 0 1-1.399-.205c-1.921-.616-3.017-2.462-2.702-4.462a4.996 4.996 0 0 1 4.996-4.277c.475-.005.947.064 1.399.206 1.933.614 3.024 2.46 2.707 4.462h-.005Z"
              />
              <path
                fill="#003087"
                d="m109.205 19.131-5.367 9.059-2.723-8.992a.69.69 0 0 0-.664-.492h-4.842a.516.516 0 0 0-.496.689l4.88 15.146-4.413 7.138a.517.517 0 0 0 .442.794h5.217a.858.858 0 0 0 .741-.418l13.632-22.552a.516.516 0 0 0-.446-.789h-5.215a.858.858 0 0 0-.746.417Z"
              />
              <path
                fill="#0070E0"
                d="m161.982 11.387-3.962 25.079a.637.637 0 0 0 .365.683c.084.04.176.06.269.06h4.689a.688.688 0 0 0 .689-.586l3.963-25.079a.637.637 0 0 0-.146-.517.645.645 0 0 0-.488-.225h-4.69a.69.69 0 0 0-.689.585Z"
              />
              <path
                fill="#001C64"
                d="M37.146 22.26c-1.006 5.735-5.685 10.07-11.825 10.07h-3.898c-.795 0-1.596.736-1.723 1.55l-1.707 10.835c-.099.617-.388.822-1.013.822h-6.27c-.634 0-.784-.212-.689-.837l.72-7.493-7.526-.389c-.633 0-.862-.345-.772-.977l5.135-32.56c.099-.617.483-.882 1.106-.882h13.023c6.269 0 10.235 4.22 10.72 9.692 3.73 2.52 5.474 5.873 4.72 10.168Z"
              />
              <path
                fill="#0070E0"
                d="m12.649 25.075-1.907 12.133-1.206 7.612a1.034 1.034 0 0 0 1.016 1.19h6.622a1.27 1.27 0 0 0 1.253-1.072l1.743-11.06a1.27 1.27 0 0 1 1.253-1.071h3.898A12.46 12.46 0 0 0 37.617 22.26c.675-4.307-1.492-8.228-5.201-10.165a9.96 9.96 0 0 1-.12 1.37 12.461 12.461 0 0 1-12.295 10.54h-6.1a1.268 1.268 0 0 0-1.252 1.07Z"
              />
              <path
                fill="#003087"
                d="M10.741 37.208H3.03a1.035 1.035 0 0 1-1.018-1.192L7.208 3.072A1.268 1.268 0 0 1 8.46 2H21.7c6.269 0 10.827 4.562 10.72 10.089a11.567 11.567 0 0 0-5.399-1.287H15.983a1.27 1.27 0 0 0-1.254 1.071l-2.08 13.202-1.908 12.133Z"
              />
            </g>
            <defs>
              <clipPath id="a">
                <path fill="#fff" d="M0 0h166v44.01H0z" transform="translate(2 2)" />
              </clipPath>
            </defs>
          </svg>
          <!--          <img alt="paypal method" class="b-loaded" :src="fields?.paypal_icon" />-->
        </label>
      </div>
    </div>

    <div v-if="cart.paypalEnabled" class="divider">
      <span class="title">{{ fields?.tr_or_checkout_with_cc }}</span>
    </div>

    <form id="form" @submit.prevent="submit">
      <div
        class="step-title credit-card-title pb-4 my-4 d-flex flex-row align-items-center justify-content-between"
      >
        <h2 class="title">{{ fields?.tr_credit_card }}</h2>
        <img
          :alt="fields?.form_credit_card_icon ? 'credit cards' : ''"
          class="credit-cards"
          :height="fields?.form_credit_card_icon ? 20 : 0"
          :src="fields?.form_credit_card_icon ? fields.form_credit_card_icon : ' '"
        />
      </div>

      <!-- Credit Card Number -->
      <FieldCardNumber
        :text="fields?.tr_card_number_text"
        :icons="fields?.card_icon_brands"
        @change="(v) => (form.card_number = v)"
        :valid="v.card_number"
      />

      <!-- Credit Card Security Code -->
      <FieldCardCVC
        :text="fields?.tr_card_security_code_text"
        :cvv_popup_title="fields?.tr_cvv_popup_title"
        :cvv_popup_html="fields?.tr_cvv_popup_html"
        :cvv_popup_image="fields?.cvv_popup_credit_card_image"
        @change="(v) => (form.card_cvc = v)"
        :valid="v.card_cvc"
      />

      <!-- Expiration Date Columns -->
      <FieldExpirationDate
        :expiration_text="fields?.tr_expiration"
        :month_text="fields?.tr_month_text"
        :year_text="fields?.tr_year_text"
        @change-month="(v) => (form.card_exp_month = v)"
        @change-year="(v) => (form.card_exp_year = v)"
        :validMonth="v.card_exp_month"
        :validYear="v.card_exp_year"
      />

      <Reach v-if="displayReach" :text="fields?.tr_reach_badge_content" />

      <div class="step-title step-2 d-flex flex-row mt-5">
        <img
          :alt="fields?.personal_information_icon ? fields?.tr_personal_information_text : ''"
          class="mr-3 mb-3"
          :height="fields?.personal_information_icon ? 20 : 0"
          :src="fields?.personal_information_icon ? fields.personal_information_icon : ''"
          :width="fields?.personal_information_icon ? 20 : 0"
        />
        <h2 class="title">{{ fields?.tr_personal_information_text }}</h2>
      </div>

      <!-- First Name -->
      <FieldBasic
        field_id="first_name"
        :defaultValue="userData.first_name"
        :label="fields?.tr_first_name_text"
        maxLength="30"
        type="text"
        autoFill="cc-given-name"
        @change="(v) => (form.first_name = v)"
        :valid="v.first_name"
      />

      <!-- Last Name -->
      <FieldBasic
        field_id="last_name"
        :defaultValue="userData.last_name"
        :label="fields?.tr_last_name_text"
        maxLength="30"
        type="text"
        autoFill="cc-family-name"
        @change="(v) => (form.last_name = v)"
        :valid="v.last_name"
      />

      <!-- Email Address -->
      <FieldBasic
        field_id="email"
        :label="fields?.tr_email_address_text"
        :defaultValue="userData.email"
        maxLength="40"
        type="email"
        autoFill="email"
        @change="(v) => (form.email = v)"
        :valid="v.email"
      />

      <!-- Phone Number-->
      <FieldPhoneNumber
        :label="fields?.tr_phone_number_text"
        :defaultValue="userData.phone"
        @change="(v) => (form.phone = v)"
        @valid="(v) => (phoneValid = v)"
        :valid="v.phone"
      />

      <div class="step-title step-2 d-flex flex-row mt-5">
        <img
          :alt="fields?.shipping_information_icon ? fields?.tr_shipping_information_text : ''"
          class="mr-3 mb-3"
          :height="fields?.shipping_information_icon ? 20 : 0"
          :src="fields?.shipping_information_icon ? fields?.shipping_information_icon : ''"
          srcset=""
          :width="fields?.shipping_information_icon ? 20 : 0"
        />
        <h2 class="title">{{ fields?.tr_shipping_information_text }}</h2>
      </div>

      <!-- Address -->
      <FieldBasic
        field_id="address"
        :label="fields?.tr_address_text"
        :defaultValue="userData.address"
        maxLength="40"
        type="text"
        autoFill="street-address"
        @change="(v) => (form.address = v)"
        :valid="v.address"
      />

      <!-- City -->
      <FieldBasic
        field_id="city"
        :label="fields?.tr_city_text"
        :defaultValue="userData.city"
        maxLength="40"
        type="text"
        autoFill="address-level2"
        @change="(v) => (form.city = v)"
        :valid="v.city"
      />

      <!-- Country -->
      <FieldCountry
        :defaultValue="userData.country"
        :label="fields?.tr_country_text"
        @change="(v) => (form.country = v)"
        :valid="v.country"
      />

      <div class="two-column">
        <!-- State -->
        <FieldState
          :label="fields?.tr_state_text"
          :defaultValue="userData.state"
          :placeholder="fields?.tr_region_text"
          @change="(v) => (form.state = v)"
          :valid="v.state"
        />
        <!-- Zip/Postal Code -->
        <FieldBasic
          field_id="zip"
          :defaultValue="userData.zip"
          :label="fields?.tr_zip_text"
          maxLength="40"
          type="text"
          autoFill="postal-code"
          @change="(v) => (form.zip = v)"
          :valid="v.zip"
        />
      </div>

      <TermsBox
        v-if="cleanCheck || directCheck || directAffiliate"
        @change="(v) => (form.terms = v)"
        :valid="v.terms"
        :label="fields?.tr_terms_conditions_checkbox_text"
      />

      <!-- Complete Purchase Button -->
      <CompletePurchaseButton
        :label="fields?.tr_complete_purchase_text"
        :sslLabel="fields?.tr_encrypted_checkout_text"
        :secureImage="fields?.secure_payments_icon"
        :disabled="loading"
      />

      <div
        id="card-fields__processing-error"
        style="background-color: red; color: #fff; font-weight: bold"
        v-if="error"
      >
        <p style="display: block; padding: 10px; margin: 10px" v-text="error"></p>
      </div>

      <div class="ct_image_wrap cc-img mb-4 mt-4">
        <picture>
          <img
            alt=""
            class="no-lazy w-100"
            :src="fields?.secure_credit_card_image_after_submit_button"
          />
        </picture>
      </div>
    </form>

    <LoaderOverlay :color="fields?.hero_section_bg_color" v-if="loading" />
  </section>
</template>

<style scoped lang="scss">
.w_radio {
  padding: 0;

  label {
    padding: 10px 0;
    max-height: 55px;

    img,
    svg {
      height: 33px;
    }
  }
}
</style>

<script setup>
import { reactive, ref, nextTick, watch } from 'vue'
import FieldCardNumber from './form/FieldCardNumber.vue'
import Reach from './Reach.vue'
import FieldCardCVC from './form/FieldCardCVC.vue'
import FieldExpirationDate from './form/FieldExpirationDate.vue'
import FieldBasic from './form/FieldBasic.vue'
import FieldPhoneNumber from './form/FieldPhoneNumber.vue'
import FieldCountry from './form/FieldCountry.vue'
import FieldState from './form/FieldState.vue'
import CompletePurchaseButton from './form/CompletePurchaseButton.vue'
import { useCartStore } from '../state/cart'
import PaypalComponent from './form/PaypalComponent.vue'
import { useVuelidate } from '@vuelidate/core'
import { required, email, helpers, requiredIf, sameAs } from '@vuelidate/validators'
import LoaderOverlay from './form/LoaderOverlay.vue'
import axios from 'axios'
import SmoothScroll from 'smooth-scroll'
import TermsBox from './form/TermsBox.vue'

const userData = reactive(window.userData)

const form = reactive({
  card_number: null,
  card_cvc: null,
  card_exp_month: null,
  card_exp_year: null,
  first_name: null,
  last_name: null,
  email: null,
  phone: null,
  address: null,
  country: null,
  state: null,
  zip: null,
  city: null,
  terms: true
})

const error = ref('')
const loading = ref(false)
const paypalFunnel = ref(false)

const fields = window.msg
const cart = useCartStore()

const timeToAutoSubmit = Number(cart.autoSubmitDelay) || 10
const timeToAutoSubmitInMiliseconds = timeToAutoSubmit * 1000

const phoneValid = ref(false)
const phoneMustBeValid = (value) => phoneValid.value

const cleanCheck =
  (window.isMobile === 'false' && fields.enable_clean_version_in_desktop) ||
  (window.isMobile === 'true' && fields.enable_clean_version_in_mobile)

const directAffiliate = window?.affiliate.includes('-direct')
const directCheck = fields.clean_checkout_if_direct_customer && window.directCheck
const directReachGlobal = window.reach_global?.reach_direct && directAffiliate
const directReachLocal = fields?.reach_locally_direct && directAffiliate

const displayReach =
  (fields?.reach_locally ||
    directReachGlobal ||
    directReachLocal ||
    window.reach_global?.reach_global) &&
  window.general_settings?.merchant_id

if (cleanCheck || directCheck) {
  form.terms = false
}

// Validations
const validationMessage = helpers.withMessage(
  fields?.tr_field_is_required_text || 'Field is required',
  required
)
const rules = {
  card_number: {
    required: helpers.withMessage(
      fields?.tr_card_number_error_text || 'Card number is required',
      required
    )
  },
  card_cvc: { required: validationMessage },
  card_exp_month: { required: validationMessage },
  card_exp_year: { required: validationMessage },
  first_name: { required: validationMessage },
  last_name: { required: validationMessage },
  email: {
    required: validationMessage,
    email: helpers.withMessage(fields?.tr_email_is_not_valid_text || 'Email is not vaild', email)
  },
  phone: {
    phoneMustBeValid: helpers.withMessage(
      fields?.tr_phone_is_not_valid_text || 'Phone number is not valid',
      phoneMustBeValid
    )
  },
  address: { required: validationMessage },
  country: { required: validationMessage },
  state: { required: validationMessage },
  zip: { required: validationMessage },
  city: { required: validationMessage },
  terms: {
    required: requiredIf(function () {
      return cleanCheck || directCheck || directAffiliate
    }),
    sameAs: (val) => val === true
  }
}

const v = useVuelidate(rules, form, { $autoDirty: true })
// End Validations

const startPaypalFunnel = () => {
  paypalFunnel.value = true
}

watch(
  () => cart.popoverInteracted,
  (newVal, oldVal) => {
    if (newVal === 'accept' || newVal === 'deny') {
      console.log(newVal)
      submit()
    }
  }
)

// Form submission
const submit = async () => {
  const isFormCorrect = await v.value.$validate()

  if (!isFormCorrect) {
    let domRect = document.querySelector('.error')
    var scroll = new SmoothScroll('[data-easing="easeInOutQuad"]', {
      easing: 'easeInOutQuad',
      speed: 500,
      speedAsDuration: true,
      offset: 25
    })
    scroll.animateScroll(domRect)

    return
  }

  const productSectionWrapper = document.querySelector('.product-section-wrapper')

  if (cart.showPopover && cart.warrantyState !== true && cart.popoverInteracted == false) {
    const element = document.getElementById('popoverWarranty')
    if (element) {
      productSectionWrapper.style.pointerEvents = 'none'
      cart.popoverInteracted = true
      cart.popoverShow = true

      nextTick(() => {
        const yOffset = window.innerHeight / 2 - element.getBoundingClientRect().height / 2
        const y = element.getBoundingClientRect().top + window.pageYOffset - yOffset

        window.scrollTo({ top: y, behavior: 'smooth' })

        const denyInteraction = function (event) {
          if (!event || event.target.id !== 'popoverWarranty') {
            cart.popoverInteracted = 'deny'
            document.removeEventListener('click', denyInteraction)
          }
        }

        document.addEventListener('click', denyInteraction)
        setTimeout(denyInteraction, timeToAutoSubmitInMiliseconds)
      })

      return
    }
  }

  loading.value = true

  const navigator = window.navigator
  const browserData = {
    acceptHeader: 'application/json',
    colorDepth: screen.colorDepth,
    javaEnabled: navigator.javaEnabled(),
    javaScriptEnabled: true,
    language: navigator.language,
    screenHeight: screen.height,
    screenWidth: screen.width,
    timeZoneOffset: new Date().getTimezoneOffset().toString(),
    userAgent: navigator.userAgent
  }

  const requestData = {
    data: form,
    affiliate: window.affiliate,
    products: cart.$state,
    upsell_path: fields?.credit_card_upsell,
    return_to: window.location.href,
    browserData: browserData
  }

  axios
    .post('/wp-json/checkout/v1/order', requestData)
    .then((response) => {
      const data = response.data
      loading.value = false

      productSectionWrapper.style.pointerEvents = 'all'

      if (data.result === 'ERROR') {
        // Validation / Payment error
        error.value = data.message

        nextTick(() => {
          const yOffset = -100
          const element = document.getElementById('card-fields__processing-error')
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset

          window.scrollTo({ top: y, behavior: 'smooth' })
        })
      } else if (data.result === 'SUCCESS') {
        // Successful payment
        window.location.href = cart.nextStep + '?orderId=' + data.message.orderId
      } else if (data.result === 'MERC_REDIRECT') {
        // 3DS Bank Auth
        const message = data.message
        if (message && message.url) {
          window.location.href = message.url
        } else if (message && message.script) {
          eval(message.script)
        }
      }
    })
    .catch((error) => {
      console.error(error)
      this.loading = false
    })
}
// End form submission
</script>
